import { render, staticRenderFns } from "./visualizacaoAnexoAto.vue?vue&type=template&id=52eae97b&scoped=true"
import script from "./visualizacaoAnexoAto.vue?vue&type=script&lang=js"
export * from "./visualizacaoAnexoAto.vue?vue&type=script&lang=js"
import style0 from "./visualizacaoAnexoAto.vue?vue&type=style&index=0&id=52eae97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eae97b",
  null
  
)

export default component.exports